module.exports = __webpack_public_path__ + "img/Blast_Off_Club_House27.1db63b96.jpg";